import { render, staticRenderFns } from "./TempRankingConfirmationList.vue?vue&type=template&id=6a64fecb&scoped=true"
import script from "./TempRankingConfirmationList.vue?vue&type=script&lang=js"
export * from "./TempRankingConfirmationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64fecb",
  null
  
)

export default component.exports